module.exports = __webpack_public_path__ + "static/media/logo.09ea57be.png";


//////////////////
// WEBPACK FOOTER
// ./src/Frontend/assets/logo.png
// module id = 333
// module chunks = 0